export default __webpack_public_path__ + "static/media/kid23.ced95cd9.jpg";